import { instance } from "apis/interceptor";
import { ResponseType } from "apis/meetings/meeting-reservation";
import { TFilter, TMetaData, TVisitorsDataTable } from "types/analytics.types";

//INFO: 방문자 현황 데이터 메타데이터 조회
export const getVisitorsAnalyticsMetaData = async (): Promise<ResponseType<TMetaData[]>> => {
  try {
    const res = await instance.get("/analytics/visitors/datatable/visitor/metadata");
    return { success: true, data: res.data.content };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

export type TVisitorsDataTableRes = {
  totalSearchNumber: number;
  totalPageNumber: number;
  nowPageNumber: number;
  visitorsDashboards: TVisitorsDataTable[];
};

//INFO: 방문자 현황 데이터 조회
export const getVisitorsAnalyticsData = async (
  page: number,
  period: { start: string; end: string },
  filters: TFilter[]
): Promise<ResponseType<TVisitorsDataTableRes>> => {
  try {
    const res = await instance.post("/analytics/visitors/datatable/visitor", {
      page,
      period,
      filters,
    });
    return { success: true, data: res.data };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//*INFO: 방문자 현황 데이터 CSV 다운로드
export const downloadVisitorsAnalyticsData = async (
  startDateString: string,
  endDateString: string
): Promise<ResponseType<string>> => {
  try {
    const res = await instance.post("/analytics/visitors/datatable/visitor/csv", {
      start: startDateString,
      end: endDateString,
    });
    return { success: true, data: res.data.downloadUrl };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};
